import Courses from '@/assets/illustrations/courses.svg'
import Goals from '@/assets/illustrations/goals.svg'
import Journal from '@/assets/illustrations/journal-2.svg'
import Resources from '@/assets/illustrations/resources-002.svg'

export const dashboardBaseUrl = `/dashboard`

const DashboardLinks = [
  {
    name: 'My Courses',
    desc: 'Keep track of all the courses you have signed up for. Find the links to join LIVE classroom.',
    route: `${dashboardBaseUrl}/events`,
    icon: Courses,
    objectPosition: '50% 100%',
  },
  {
    name: 'Resources',
    desc: 'Find the videos from completed sessions here. You can watch and rewatch it as and when you need.',
    route: `${dashboardBaseUrl}/resources`,
    icon: Resources,
    objectPosition: '50% 100%',
  },
  {
    name: 'Journal',
    desc: 'This is your personal and private space to capture your notes and your reflections across all course on the Thrive Cafe platform. You can access it both inside and outside the classroom.',
    route: `${dashboardBaseUrl}/journal`,
    icon: Journal,
    objectPosition: '50% 100%',
  },
  {
    name: 'Goals',
    desc: 'Write down your goals, and keep of your progress',
    route: `${dashboardBaseUrl}/goals`,
    icon: Goals,
    objectPosition: '50% 100%',
  },
]

export default DashboardLinks
